import Vue from 'vue'
import App from './App.vue'
import router from './router'
import './assets/font/font.css'
import Navigation from 'vue-navigation'
// import fastClick from 'fastclick'
import store from './store/index'
import axios from 'axios'
import './directive'
import filters from './assets/js/filters.js'
import 'lib-flexible'
import '../src/assets/css/reset.css'
import { CountDown } from 'vant';
import { Lazyload, Dialog, ImagePreview, Toast } from 'vant';
import {divide,multiply, shareGetOpenId} from "./assets/js/common";
// babel
import 'babel-polyfill'
import Es6Promise from 'es6-promise'
require('es6-promise').polyfill()
Es6Promise.polyfill()

Vue.prototype.$divide=divide;
Vue.prototype.$multiply=multiply;
// options 为可选参数，无则不传
Vue
  .use(Navigation, {router, store, keyName: 'rv2go'})
  .use(Lazyload)
  .use(Dialog)
  .use(ImagePreview)
  .use(Toast)
  .use(CountDown);

Vue.prototype.$axios = axios
Vue.config.productionTip = false

// 忽略微信标签
Vue.config.ignoredElements = ['wx-open-launch-weapp']

// 过滤器
for (let key in filters) {
  Vue.filter(key, filters[key])
}


// 路由
router.beforeEach((to, from, next) => {
  var ua = window.navigator.userAgent.toLowerCase();
  if (to.meta.title) document.title = to.meta.title
 if (ua.match(/MicroMessenger/i) == 'micromessenger') {
    if(to.name == 'vehicleDetail' || to.name == 'orderList' || to.name =='camperDetail'){
      if(localStorage.getItem('pathDetail') || (localStorage.getItem('tt') && localStorage.getItem('wxOpenId'))){
        next()
      } else {
        let num = 1;
        if(to.name == 'orderList'){
          num = 2;
        }
        if(to.name =='camperDetail'){
          num = 3;
        }
        localStorage.setItem('pathDetail', 'true')
        shareGetOpenId(num, to);
      }
    } else {
      console.log('rout333333');
      next()
    }
  } else {
    next()
  }
});


window.vm = new Vue({
  render: h => h(App),
  router,
  store,
}).$mount('#app')



// WEBPACK FOOTER //
// ./src/main.js